import { Injectable } from '@angular/core';
import { ActivatedRoute,
        ActivatedRouteSnapshot,
        CanDeactivate,
        CanActivate, CanLoad, Route, Router, RouterStateSnapshot, 
        UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { RETURN_URL_QUERY_PARAM, safeReturnUrl } from '../utils/return-url.util';

/**
 * TODO: This might be a duplicate of BasicAuthGuard. Like it, it sends logged-out users to /login
 * with the page they wanted as `returnUrl`, and login brings them back.
 */
// from https://www.agiratech.com/how-to-use-angular-route-guards-angular-authentication/
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService implements CanActivate, CanLoad {

  constructor(private router: Router, private baseService: BaseService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkToken(state.url);
  }

  canLoad(route: Route): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkToken();
  }

  checkToken(requestedUrl?: string) {
    if (this.baseService.isLoggedIn) {
      return true;
    } else {
        this.baseService.showNotification("You can't access that page")
        const returnUrl = safeReturnUrl(requestedUrl)
        return this.router.createUrlTree(['/login'], returnUrl ? { queryParams: { [RETURN_URL_QUERY_PARAM]: returnUrl } } : {});
    }
  }
}

@Injectable()
export class CanExitGuard implements CanDeactivate<CanExit> {
 canDeactivate(component: CanExit) {
   if (component.canDeactivate) {
     return component.canDeactivate();
   }
   return true;
 }
}

export interface CanExit {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}
